import { Pipe, PipeTransform } from '@angular/core';
import { BulkWasteItem } from '../models/bulk-waste.model';
import { BulkWasteServiceOptions } from '../models/service-details.model';

@Pipe({
  name: 'adaptBulkWasteServiceOptions',
  standalone: true,
})
export class AdaptBulkWasteServiceOptionsPipe implements PipeTransform {
  public transform(value: { items: BulkWasteItem[] } | null): BulkWasteServiceOptions | null {
    if (value?.items?.length) {
      const options = value.items;
      const groupByCategory = Object.groupBy(options, ({ groupName }) => groupName) as Record<string, BulkWasteItem[]>;
      const categories = Object.entries(groupByCategory).map(([name, items]) => ({ name, items }));

      return {
        categories,
        quantityLimits: { min: 1, max: 99 },
      };
    }

    return null;
  }
}
